module.exports = __webpack_public_path__ + "static/media/7_r_derevo_74.48_36.85.99f8032c.png";